export default {
    title_list: 'Артефакты',
    title_page: 'Артефакт',
    title_create_page: 'Создать артефакт',
    title_edit_page: 'Изменить артефакт',

    labels: {
        images: 'Изображения',
        documents: 'Документы',
        drag_in_drop: 'Перенесите или нажмите чтобы выбрать файлы',
        file_error: 'Файл {f} не соответствует ограничениям',
        document: 'Документ',
        document_type: 'Тип документа',
    },

    filter: {
        labels: {
            title: 'Название',
            user_id: 'Пользователь',
            country_id: 'Страна',
            is_published: 'Публичный',
        }
    },

    table: {
        labels: {
            id: 'ID',
            image: 'Изображение',
            title: 'Название',
            user_id: 'Пользователь',
            is_published: 'Публичный',
            country_id: 'Страна',
            is_main: 'На главной',
        }
    },

    buttons: {

    },

    form: {
        types: 'Типы',
        tags: 'Тэги',
        user_id: 'Пользователь',
        countries: 'Страна',
        occasion_id: 'Ассоциация',
        title: 'Название',
        value_id: 'Стоимость',
        when_acquired: 'Когда приобретен',
        old_is_it: 'Сколько этому лет?',
        origin_type_id: 'How old is it? (type)',
        origin_year: 'Год производства',
        origin_century_id: 'Век производства',
        market: 'Магазин',
        where_acquired: 'Где приобретен',
        artist: 'Изготовитель',
        height: 'Высота',
        width: 'Ширина',
        depth: 'Глубина',
        current_location: 'Текущее нахождение',
        body: 'Описание',
        is_published: 'Публичный',
        is_inspiration: 'Вдохновение',
        visible: 'Отображается по условиям подписки',

        is_main: 'Отображается на главной странице',
        is_main_position: 'Порядок отображения на главной странице',

        size_unit_id: 'Ед. измерения размера',
        weight: 'Вес',
        weight_unit_id: 'Ед. измерения веса',
    },
}
